export default "__VITE_ASSET__2129f4ef__"